import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
import Input from "../../../components/input/Input";
import Textarea from "../../../components/textarea/Textarea";
import Button from "../../../components/button/Button";

export default function AboutClinicForm({ bg = "--dark-blue" }) {
  const { t } = useTranslation();

  return (
    <StyledAboutClinicForm $bg={bg}>
      <div className="container">
        <div className="about-clinic-form__wrap">
          <h1>{t("aboutClinicFormTitle")}</h1>
          <div className="about-clinic-form__form">
            <Input
              type="text"
              label={t("aboutClinicFormName")}
              placeholder={t("aboutClinicFormNamePlaceholder")}
              id="aboutClinicFormName"
            />
            <Input
              type="text"
              label={t("aboutClinicFormPhone")}
              placeholder={t("aboutClinicFormPhonePlaceholder")}
              id="aboutClinicFormPhone"
            />
            <Textarea
              label={t("aboutClinicFormMsg")}
              placeholder={t("aboutClinicFormMsgPlaceholder")}
              id="aboutClinicFormMsg"
            />
            <div className="about-clinic-form__btn">
              <Button padding={[20, 60]}>{t("aboutClinicFormBtn")}</Button>
            </div>
          </div>
        </div>
      </div>
    </StyledAboutClinicForm>
  );
}

const StyledAboutClinicForm = styled.section`
  padding: 140px 0;
  background-color: var(${({ $bg }) => $bg});

  .about-clinic-form {
    &__wrap {
      background-color: var(--bg);
      padding: 120px 200px;

      h1 {
        color: var(--title);
        text-align: center;
      font-size: var(--fs-section-title);
        font-style: normal;
      font-weight: var(--fw-semibold);
      line-height: var(--lh-title);
        margin-bottom: 40px;
      }
    }

    &__form {
      display: flex;
      flex-direction: column;
      gap: 40px;
    }

    &__btn {
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
`;
